import React, { useContext } from 'react'
import { Row, Col, Logo, Container } from 'react-angle-dashboard-components'
import { LayoutContext } from '../../context/layout'

export const Footer: React.FC = () => {
  const { companyInfo, legalLinks, contacts, menu, subParagraphs } =
    useContext(LayoutContext)

  return (
    <section className="bg-dark pt-3 pb-5">
      <Container>
        <Row className="mb-4">
          <Col xs="12" sm="2">
            <Logo size="lg" />
          </Col>
          <Col className="pt-3">
            <Row className="pl-3">
              {Object.keys(menu).map((k: any) => (
                <Col xs="12" sm="3" className="px-0 pb-4" key={k}>
                  <b
                    style={{
                      fontFamily: 'Sentinel,sans-serif'
                    }}
                    className="d-block text-white fs-14 mb-3"
                  >
                    {k}
                  </b>
                  {(menu as any)[k].map((l: any, i: number) => (
                    <a
                      href={l.link}
                      key={i}
                      className="d-block fs-14 text-white mb-1"
                    >
                      {l.text}
                    </a>
                  ))}
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <div className="mb-4 text-center-sm-on mt-4">
          {contacts.map((c, i) => (
            <p key={i} className="text-white mb-0">
              <span className="text-white ">{c.text}:</span> {c.value}{' '}
            </p>
          ))}
        </div>
        <section className="text-white text-center-sm-on">
          <span className="mr-3">{companyInfo}.</span>
          <span className="text-right">
            <br />
            {legalLinks.map((l, i) => (
              <>
                <u key={i}>
                  <a
                    href={l.link}
                    style={{ color: 'white', textDecoration: 'underline' }}
                    className={`text-white ${
                      i + 1 !== legalLinks.length ? 'mr-2' : ''
                    }`}
                  >
                    {l.text}
                  </a>
                </u>
                <br />
              </>
            ))}
          </span>
        </section>
        <hr className="text-white" />

        {subParagraphs.map((p, i) => (
          <p key={i} className={i === 0 ? 'mt-2' : ''}>
            <small className="text-white">{p}</small>
          </p>
        ))}
      </Container>
    </section>
  )
}
